(() => {
  if (customElements.get('product-card-addon')) {
    return;
  }

  class ProductCardAddon extends HTMLElement {
    constructor() {
      super();

      this.variantsSelect = this.querySelector('[data-product-addon-select]');
      this.media = this.querySelector('[data-product-addon-media]');
    }

    connectedCallback() {
      this.swatches = this.querySelectorAll('[data-swatches] input');

      this.swatches.forEach((swatch) => {
        swatch.addEventListener('change', this.onSwatchChange.bind(this));
      });

      if (!this.variantsSelect) return;

      this.variantsSelect.addEventListener('change', this.onVariantChange.bind(this));
      this.syncSwatchToSelectedVariant();
      this.onVariantChange({ target: this.variantsSelect });
    }

    syncSwatchToSelectedVariant() {
      const selectedOption = this.variantsSelect.selectedOptions[0];
      const swatchPosition = this.swatches[0]?.dataset.optionPosition;

      if (!selectedOption || !swatchPosition) return;

      const optionValue = selectedOption.getAttribute(`data-option${swatchPosition}`);
      const swatchInput = this.querySelector(`[data-swatches] input[value="${optionValue}"]`);

      if (swatchInput) {
        swatchInput.checked = true;
      }
    }

    onSwatchChange(event) {
      const optionSelector = `option[data-option${
        event.target.dataset.optionPosition
      }="${event.target.value}"]`;
      const option = this.variantsSelect.querySelector(optionSelector);

      if (!option) return;

      this.variantsSelect.value = option.value;
      this.variantsSelect.dispatchEvent(new Event('change'));
    }

    onVariantChange(event) {
      const selectedOption = event.target.selectedOptions[0];

      this.querySelectorAll('[data-product-link]').forEach((link) => {
        link.setAttribute('href', `${this.dataset.url}${selectedOption.value}`);
      });

      const primaryImage = this.media?.querySelector('[data-primary-image]');

      if (!selectedOption.dataset.imageSrc || !primaryImage) {
        return;
      }

      primaryImage.src = selectedOption.dataset.imageSrc;

      if (selectedOption.dataset.imageSrcset) {
        primaryImage.srcset = selectedOption.dataset.imageSrcset;
      }
    }
  }

  customElements.define('product-card-addon', ProductCardAddon);
})();
